import Link from '@next-app/components/elements/Link/Link';
import ResponsiveImageClient from '@next-app/components/elements/ResponsiveImage/ResponsiveImageClient';
import Conditional from '@next-app/components/Conditional';
import ReviewStars from '@next-app/components/PDP/PDPReviews/ReviewStars';
import PDPCarouselButton from '../../PDP/PDPCarousels/PDPCarouselButton';
import classes from '../../PDP/PDPCarousels/pdp-carousels.module.scss';
import { CarouselProducts } from '@next-app/interface/PDP/PDPRecentlyViewedProducts';
import { hideDynamicModal } from '@next-app/utils/common-utils';
import constants from '@next-app/constants/constants';

const STORE_PICKUP_ONLY = constants.LLConstants.STORE_PICKUP_ONLY;

interface ProductRecommendationProps {
  group: CarouselProducts[];
  classnameItem?: string;
  classnameItemName?: string;
  classnameItemButton?: string;
  recommendationTitle?: string;
  carouselId?: string;
  mboxid?: string;
  enableStoreOnlyItems: boolean;
  isStoreSelected: boolean;
  gsaUser: boolean;
  justifyClass?: string;
  classnameRegPrice?: string;
  classnameImage?: string;
}

const ProductRecommendation: React.FC<ProductRecommendationProps> = ({
  group,
  classnameItem = '',
  classnameItemName = '',
  classnameItemButton = '',
  recommendationTitle = '',
  carouselId = '',
  mboxid = '',
  enableStoreOnlyItems,
  isStoreSelected,
  gsaUser,
  justifyClass = '',
  classnameRegPrice = '',
  classnameImage = '',
}) => (
  <div className="row justify-content-center h-100">
    <div
      className={`${classes.item} col-lg-10 d-flex p-0 ${
        !recommendationTitle ? classes['treding-items'] : ''
      }`}
    >
      {group?.map((item, itemIndex) => (
        <div
          key={`recommendation-${itemIndex}`}
          className={`${classes['carousel-items']} item-wrapper ${classnameItem} ${classes[justifyClass]}`}
        >
          <div
            className={`fw-bold ${classes['product-name']} ${classnameItemName}`}
          >
            <Link
              data-carouseldtmflag={true}
              href={item?.seoURL}
              onClick={() => hideDynamicModal()}
            >
              <span className={classnameImage}>
                <ResponsiveImageClient
                  mobileImagePath={item?.imageURL}
                  tabletImagePath={item?.imageURL}
                  desktopImagePath={item?.imageURL}
                  altText={item?.altText}
                  isFullUrl={false}
                  fill={true}
                  className="position-static"
                />
              </span>
              <Conditional if={item?.storeOnly}>
                <span className={classes['store-pickup']}>
                  {STORE_PICKUP_ONLY}
                </span>
              </Conditional>
              <span
                className={`fw-bold ${classes['item-name']} ${
                  !recommendationTitle
                    ? `ll-fs-14 ${classes['item-name-no-title']}`
                    : ''
                }`}
                dangerouslySetInnerHTML={{ __html: item?.name }}
              ></span>
            </Link>

            <Conditional if={item?.isOnSale && !item?.hasGSAPrice}>
              <p className={`${classes['product-price-original']}`}>
                <span className={classes['product-price-sale']}>
                  {item?.salePriceRange}
                </span>
                <span
                  className={classnameRegPrice}
                >{`reg. ${item?.listPriceRange}`}</span>
              </p>
            </Conditional>

            <Conditional if={gsaUser && item?.hasGSAPrice}>
              <p
                className={`${classes['product-price']} ${classes['product-price-gsa']}`}
              >
                {item?.salePriceRange} GSA
              </p>
            </Conditional>

            <Conditional if={!item?.hasGSAPrice && !item?.isOnSale}>
              <p className={`${classes['product-price']}`}>
                {item?.listPriceRange}
              </p>
            </Conditional>
          </div>

          <div className={classes['product-detail']}>
            <Conditional if={!!(item?.showRating && item?.rating)}>
              <div className={classes.rating}>
                <ReviewStars rating={item?.rating} />
                <Conditional if={recommendationTitle != ''}>
                  <span className={classes['rating-count']}>
                    <Link
                      href={item?.seoURL}
                      aria-label="Close"
                      data-bs-dismiss="modal"
                      data-dismiss="dynamicModalWrapper"
                    >
                      ({item?.reviewCount})
                    </Link>
                  </span>
                </Conditional>
              </div>
            </Conditional>

            <Conditional if={!!item?.presellDate}>
              <div className={classes['pre-sell-date']}>
                Available {item?.presellDate}
              </div>
            </Conditional>

            <Conditional
              if={
                !(
                  item?.storeOnly &&
                  (!enableStoreOnlyItems || !isStoreSelected)
                )
              }
            >
              <Conditional if={recommendationTitle != ''}>
                <PDPCarouselButton
                  product={item}
                  customClasses={classnameItemButton}
                  recommendationTitle={recommendationTitle}
                  carouselId={carouselId}
                  mboxid={mboxid}
                />
              </Conditional>
            </Conditional>

            <Conditional
              if={
                item?.storeOnly && (!enableStoreOnlyItems || !isStoreSelected)
              }
            >
              <div style={{ height: 40 }}></div>
            </Conditional>
          </div>
        </div>
      ))}
    </div>
  </div>
);

export default ProductRecommendation;
